// École Nid Douillet - Enrollment Page

import React from 'react';

const EnrollmentPage: React.FC = () => {
  return (
    <div className="container-wide py-16 space-y-12">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-neutral-900 mb-6">
          Inscription en ligne
        </h1>
        <p className="text-lg text-neutral-600 max-w-3xl mx-auto">
          Inscrivez votre enfant à l'École Maternelle Nid Douillet
        </p>
      </div>
      
      <div className="bg-white rounded-xl shadow-soft p-8">
        <h2 className="text-2xl font-bold text-neutral-900 mb-4">
          Formulaire d'inscription
        </h2>
        <p className="text-neutral-600 mb-6">
          Remplissez ce formulaire pour inscrire votre enfant. 
          Notre équipe vous contactera dans les plus brefs délais.
        </p>
        
        <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-sm text-blue-800">
            🚧 Formulaire d'inscription en cours de développement
          </p>
        </div>
      </div>
    </div>
  );
};

export default EnrollmentPage;
